/**
 * Cart Validation Component
 *
 * Prevents adding multiple main products (router packages) to cart.
 * Main products are identified by _device_variant line item property.
 *
 * Usage: Add <cart-validator></cart-validator> to theme.liquid
 */

if (!customElements.get('cart-validator')) {
  class CartValidator extends HTMLElement {
    /**
     * Check if a cart item is a main product based on properties
     * Main products have _device_variant property but not _subscription
     */
    isMainProduct(cartItem) {
      if (!cartItem.properties) return false;

      const hasDeviceVariant = '_device_variant' in cartItem.properties;
      const isSubscription = cartItem.properties._subscription === 'true';

      return hasDeviceVariant && !isSubscription;
    }

    /**
     * Check cart for existing main products
     */
    async checkCartForMainProduct() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        const mainProductInCart = cart.items.find((item) => this.isMainProduct(item));

        return mainProductInCart || null;
      } catch (error) {
        console.error('[Cart Validation] Error fetching cart:', error);
        return null;
      }
    }

    /**
     * Validate add-to-cart action for main products
     * Returns { valid: boolean, error?: string }
     */
    async validateAdd(items) {
      const addingMainProduct = items.some((item) => {
        const hasDeviceVariant = item.properties?._device_variant;
        const isSubscription = item.properties?._subscription === 'true';
        return hasDeviceVariant && !isSubscription;
      });

      if (!addingMainProduct) {
        return { valid: true };
      }

      const existingMainProduct = await this.checkCartForMainProduct();

      if (existingMainProduct) {
        const errorMessage =
          window.Shopify?.locale?.content?.cart_validation_error ||
          'You cannot add more than one router package to your cart. Please remove one before adding another.';

        return {
          valid: false,
          error: errorMessage,
        };
      }

      return { valid: true };
    }
  }

  customElements.define('cart-validator', CartValidator);
}
